import axios from 'axios';
import { ElMessage } from 'element-plus';

let unauthorizedHandler = () => {};

export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = typeof handler === 'function' ? handler : () => {};
}

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: 15000,
  withCredentials: true
});

service.interceptors.response.use(
  (response) => {
    const payload = response.data;
    if (payload?.code === 0) {
      return payload.data;
    }
    const message = payload?.message || '请求失败，请稍后再试';
    ElMessage.error(message);
    return Promise.reject(new Error(message));
  },
  (error) => {
    const message = error.response?.data?.message || error.message || '网络异常，请稍后重试';
    if (error.response?.status === 401) {
      unauthorizedHandler();
      ElMessage.warning('登录状态已失效，请重新登录');
    } else {
      ElMessage.error(message);
    }
    return Promise.reject(error);
  }
);

export default service;
